import * as moment from "moment";

export enum CONTACTS_TABLE_COLUMNS {
    NAME = 'Name',
    PHONE = 'Phone',
    DESCRIPTION = 'Description',
    DIAL_TO_OPEN = 'Dial-to-Open',
    RULES = 'Rules',
    TEMPORARY_RULES = 'Temporary-rules',
    ACTIONS = 'Actions',
}

export const CONTACTS_DEFAULT_START = moment().format('yyyy-MM-DDT00:00');
export const CONTACTS_DEFAULT_END = moment().add(7, 'days').format('yyyy-MM-DDT00:00');

export const CONTACTS_DEFAULT_SORT_COLUMN = CONTACTS_TABLE_COLUMNS.NAME;
export const CONTACTS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const CONTACTS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const CONTACTS_PAGE_DEFAULT_SIZE = 20;
export const CONTACTS_MAX_MEMORY_SIZE = 3000;

export const CONTACTS_TABLE_HEADER = [
    CONTACTS_TABLE_COLUMNS.NAME,
    CONTACTS_TABLE_COLUMNS.PHONE,
    CONTACTS_TABLE_COLUMNS.DESCRIPTION,
    CONTACTS_TABLE_COLUMNS.DIAL_TO_OPEN,
    CONTACTS_TABLE_COLUMNS.RULES,
    CONTACTS_TABLE_COLUMNS.TEMPORARY_RULES,
    CONTACTS_TABLE_COLUMNS.ACTIONS,
];
